import { render, staticRenderFns } from "./xskSku.vue?vue&type=template&id=38fe7b10&scoped=true&"
import script from "./xskSku.vue?vue&type=script&lang=js&"
export * from "./xskSku.vue?vue&type=script&lang=js&"
import style0 from "./xskSku.vue?vue&type=style&index=0&id=38fe7b10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe7b10",
  null
  
)

export default component.exports